import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Badge, Button, Spinner, Table } from 'react-bootstrap';
import { api } from '../../lib/api';
import { useToast } from '../../context/ToastContext';
import { useConfirm } from '../../context/ConfirmContext';

export default function ListaEmpresas() {
  const toast = useToast();
  const confirmar = useConfirm();
  const [empresas, setEmpresas] = useState(null);
  const [erro, setErro] = useState(false);

  useEffect(() => {
    api
      .get('/empresas')
      .then((r) => setEmpresas(r.data))
      .catch((err) => {
        setErro(true);
        toast.erro(err.message || 'Não foi possível carregar as empresas');
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Excluir só funciona pra empresa VAZIA (o servidor recusa e explica o que ainda existe: usuários,
  // imóveis, clientes) — nesse caso a saída é bloquear a empresa.
  async function excluir(emp) {
    if (!(await confirmar({ titulo: 'Excluir empresa', mensagem: `Excluir a empresa "${emp.e1_nome}"? Só é possível se ela não tiver usuários, imóveis nem clientes.`, variante: 'perigo', textoConfirmar: 'Excluir' }))) return;
    try {
      await api.delete(`/empresas/${emp.public_id}`);
      toast.sucesso('Empresa excluída.');
      setEmpresas((lista) => lista.filter((e) => e.public_id !== emp.public_id));
    } catch (err) {
      toast.erro(err.message || 'Não foi possível excluir a empresa');
    }
  }

  return (
    <>
      <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-4">
        <h1 className="h4 mb-0">Empresas</h1>
        <Button as={Link} to="/empresas/nova" variant="primary">
          Nova empresa
        </Button>
      </div>

      {!empresas && !erro && <Spinner animation="border" />}

      {empresas && (
        <Table hover responsive>
          <thead>
            <tr>
              <th>Nome</th>
              <th>Responsável</th>
              <th>Telefone</th>
              <th>CNPJ</th>
              <th>Status</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {empresas.map((emp) => (
              <tr key={emp.public_id}>
                <td>{emp.e1_nome}</td>
                <td>{emp.e1_responsavel}</td>
                <td>{emp.e1_telefone}</td>
                <td>{emp.e1_cnpj}</td>
                <td>
                  {emp.e1_bloqueio === 'true' ? (
                    <Badge bg="danger">Bloqueada</Badge>
                  ) : (
                    <Badge bg="success">Ativa</Badge>
                  )}
                </td>
                <td className="text-end text-nowrap">
                  <Button as={Link} to={`/empresas/${emp.public_id}`} size="sm" variant="outline-secondary">
                    Editar
                  </Button>
                  <Button size="sm" variant="outline-danger" className="ms-1" onClick={() => excluir(emp)}>
                    Excluir
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </>
  );
}
